import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  textField: {
    marginBottom: 24
  },
  fileInputFormControl: {
    marginBottom: 24
  },
  fileInput: {
    display: 'none'
  },
  fileInputLabel: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    display: 'inline-block',
    width: '100%',
    padding: '12.5px 14px',
    cursor: 'pointer',
    borderRadius: 8,
    position: 'relative',
    '&:hover': {
      borderColor: '#262626'
    },
    '&:focus': {
      borderColor: theme.palette.secondary.main,
      borderWidth: 2,
      padding: '11.5px 13px',
      '& .labelImitation': {
        color: theme.palette.secondary.main
      }
    },
    '&:active': {
      borderColor: theme.palette.secondary.main,
      borderWidth: 2,
      padding: '11.5px 13px',
      '& .labelImitation': {
        color: theme.palette.secondary.main
      }
    }
  },
  labelImitation: {
    position: 'absolute',
    fontWeight: '400',
    fontSize: 12,
    lineHeight: '16.34px',
    letterSpacing: '0.4px',
    color: '#6F6F6F',
    top: -8.5,
    left: 8,
    backgroundColor: '#FFF',
    paddingLeft: 5,
    paddingRight: 5
  },
  placeholderlImitation: {
    fontWeight: '400',
    fontSize: 14,
    lineHeight: '21px',
    letterSpacing: '0.25px',
    color: '#a6a6a6'
  }
}))

export default useStyles
